import { formatPoints, ordinal } from '../../../utils/leaderboardUtils';
import { soft } from './softStyles';

// The signed-in player's numbers for the selected week, above the picks table.
// Winners is worked out from final scores, so it fills in as games finish;
// points and rank come from the published weekly scores and stay "—" until an
// admin publishes the week.

const styles = {
  row: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '12px',
    width: '100%',
    maxWidth: '560px',
    marginBottom: '16px',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: soft.radius,
    boxShadow: `0 0 0 1px ${soft.outline}`,
    padding: '10px 14px',
    textAlign: 'left',
  },
  label: {
    fontSize: '12px',
    color: soft.muted,
  },
  value: {
    fontSize: '22px',
    fontWeight: 500,
    color: soft.text,
    lineHeight: 1.3,
    fontVariantNumeric: 'tabular-nums',
  },
  caption: {
    fontSize: '11px',
    color: soft.faint,
  },
};

const Card = ({ label, value, caption }) => (
  <div style={styles.card}>
    <div style={styles.label}>{label}</div>
    <div style={styles.value}>{value}</div>
    {caption && <div style={styles.caption}>{caption}</div>}
  </div>
);

const WeekSummary = ({ week, games, picks, myPoints, weeklyPoints, isMobile }) => {
  // Pick-the-winner games with a final score: the ✓/✗ columns in the table.
  let correct = 0;
  let decided = 0;
  (games || []).forEach((game) => {
    if (game.isPickScore) return;
    if (game.homeScore === undefined || game.awayScore === undefined) return;
    const pick = picks?.[game.id];
    if (!pick || (!pick.homeWin && !pick.awayWin)) return;
    decided += 1;
    const homeWon = Number(game.homeScore) > Number(game.awayScore);
    if (homeWon === !!pick.homeWin) correct += 1;
  });

  // Rank among everyone with a published score this week; ties share a place.
  let rank = null;
  let tied = false;
  if (myPoints) {
    const mine = Number(myPoints.total) || 0;
    const totals = Object.values(weeklyPoints || {}).map((p) => Number(p.total) || 0);
    rank = 1 + totals.filter((t) => t > mine).length;
    tied = totals.filter((t) => t === mine).length > 1;
  }

  return (
    <div style={{ ...styles.row, ...(isMobile && { maxWidth: '100%', gap: '8px' }) }} aria-label={`Your week ${week} summary`}>
      <Card
        label={`Your week ${week}`}
        value={myPoints ? `${formatPoints(myPoints.total)} pts` : '—'}
        caption={myPoints ? null : 'Not published yet'}
      />
      <Card
        label={isMobile ? 'Winners' : 'Winners picked'}
        value={decided ? `${correct} / ${decided}` : '—'}
        caption={decided ? null : 'No finished games'}
      />
      <Card
        label="Week rank"
        value={rank ? `${tied ? 'T-' : ''}${ordinal(rank)}` : '—'}
        caption={rank ? `of ${Object.keys(weeklyPoints || {}).length}` : 'Not published yet'}
      />
    </div>
  );
};

export default WeekSummary;
